var map = {
	"./de/_language.json": 2113,
	"./en/_language.json": 9301,
	"./es/_language.json": 5182,
	"./fr/_language.json": 1974,
	"./it/_language.json": 9403,
	"./pt/_language.json": 442
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9860;